<owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide *ngFor="let image of imagesList">
        <img class="rounded-[12px]" [src]="useImagePath ? (imagePath + image.src) :  image.src" alt="pic">
    </ng-template>  
  </owl-carousel-o>